import styled from "styled-components";

export const CreatePointWrapper = styled.div`
  & {
    width: 100%;
    height: 100%;
    max-width: 1180px;
    margin: 0 auto;
    padding: 0 30px;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`;
